import React from "react";

import useEscapeKey from "../hooks/useEscapeKey";

export const ToastContext = React.createContext();

function ToastProvider({ children }) {
  const [toasts, setToasts] = React.useState([]);

  const handleEscape = React.useCallback(() => {
    setToasts([]);
  }, []);

  useEscapeKey(handleEscape);

  function createToast(message, variant, solo) {
    const toast = {
      id: crypto.randomUUID(),
      message,
      variant,
    }
    if (solo) {
      setToasts([toast]);
    } else {
      const nextToasts = [
        ...toasts,
        {
          id: crypto.randomUUID(),
          message,
          variant,
        },
      ];
      setToasts(nextToasts);
    }
  }

  function dismissToast(id) {
    const nextToasts = toasts.filter((toast) => {
      return toast.id !== id;
    });

    setToasts(nextToasts);
  }

  return (
    <ToastContext.Provider value={{ toasts, createToast, dismissToast }}>
      {children}
    </ToastContext.Provider>
  );
}

export default ToastProvider;
